import { render, staticRenderFns } from "./TreatmentList.vue?vue&type=template&id=597c7784&"
import script from "./TreatmentList.vue?vue&type=script&lang=js&"
export * from "./TreatmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports